import { useEffect } from 'react'

import { headTagSpecs, seoForPath } from '../seo'

/**
 * Keeps the document head in step on client-side navigation.
 *
 * The prerenderer bakes the same tags into each static file, so this only matters once
 * the visitor starts clicking. Every tag it owns carries data-seo: the whole marked set
 * is cleared and rewritten on each navigation, so a tag left over from the previous
 * page cannot survive as a stale duplicate. Anything in index.html that must outlive a
 * navigation is deliberately unmarked.
 */
export function useSeo(pathname: string): void {
  useEffect(() => {
    const seo = seoForPath(pathname)
    document.title = seo.title

    const description = document.querySelector('meta[name="description"]')
    if (description) description.setAttribute('content', seo.description)

    for (const stale of document.querySelectorAll('[data-seo]')) stale.remove()

    for (const spec of headTagSpecs(pathname)) {
      const element = document.createElement(spec.tag)
      for (const [name, value] of Object.entries(spec.attrs)) element.setAttribute(name, value)
      element.setAttribute('data-seo', '')
      document.head.appendChild(element)
    }
  }, [pathname])
}
